// Self-healing against stale cached app shells.
//
// The recurring failure this kills: a browser caches index.html (historically
// served with no Cache-Control, so heuristic caching kept it for days) and
// keeps running an old bundle whose baked API origin / hashed assets are gone
// — the user sees "Failed to load EPK content" until a manual hard refresh.
//
// deploy.sh bakes REACT_APP_BUILD_ID into the bundle AND writes the same
// value to /build-id.txt in the release dir (served with Cache-Control:
// no-cache by nginx). If the running bundle's id ever differs from the
// server's, this forces ONE reload — the document revalidates (index.html is
// no-cache now) and the browser picks up the current release.
//
// Safety: a sessionStorage marker per server id guarantees at most one
// automatic reload per new release per tab, so a misconfigured server can
// never reload-loop the page. Any fetch problem = do nothing.
export const startBuildGuard = () => {
  const mine = process.env.REACT_APP_BUILD_ID;
  if (!mine) return; // dev server / local preview builds — guard disabled

  const check = async () => {
    try {
      const res = await fetch('/build-id.txt', { cache: 'no-store' });
      if (!res.ok) return;
      const server = (await res.text()).trim();
      // Ignore junk (a proxy error page, an HTML 404) — ids are short tokens.
      if (!server || server.length > 64 || /[<>\s]/.test(server)) return;
      if (server === mine) return;
      const key = `epk-build-reload-${server}`;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
      window.location.reload();
    } catch {
      /* offline / fetch failed — never break the page over the guard */
    }
  };

  check();
  setInterval(check, 5 * 60 * 1000);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });
};
